import { FileType } from 'components/common/graphicUploader/types';
import { DocumentOnView } from 'presentation/document/documentOnView';
import { DocumentModel } from 'shared/domain/document/documentModel';
import { DocumentTypes } from 'shared/types/document';
import { isUploadStatusSuccess } from 'shared/types/uploadStatus';
import { FileInfo } from 'setup/types/core';
import { isDocumentImage } from 'helpers/image';

export const ensureExtension = (
  title: string,
  extension: string | undefined
): string => {
  if (!extension) {
    return title;
  }

  return title.endsWith(`.${extension}`) ? title : `${title}.${extension}`;
};

export const isDownloadable = (
  document: DocumentModel | DocumentOnView | FileType
): boolean => {
  return (
    Boolean(document._id) &&
    !document.deleted &&
    document.data?.documentType === DocumentTypes.file &&
    isUploadStatusSuccess((document.data as FileInfo).uploadStatus)
  );
};

export const canDocumentBeDownloadedAndIsImage = (
  document: DocumentModel | DocumentOnView
): boolean => {
  return isDownloadable(document) && isDocumentImage(document);
};
